import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const viewsToOpenSliceName = "viewsToOpenSlice";

export interface ViewToOpen {
  viewKey: string;
}

export interface ViewsToOpenState {
  viewsToOpen: ViewToOpen[];
}

export interface ViewsToOpenRootState {
  [viewsToOpenSliceName]: ViewsToOpenState;
}

const initialState: ViewsToOpenState = { viewsToOpen: [] };

const viewsToOpenSlice = createSlice({
  name: viewsToOpenSliceName,
  initialState,
  reducers: {
    showRegisteredViews: (state: ViewsToOpenState, action: PayloadAction<string[]>) => {
      state.viewsToOpen = [
        ...state.viewsToOpen,
        ...action.payload.map((viewKey) => ({ viewKey, processed: false })),
      ];
    },
    clearRegisteredViews: (state: ViewsToOpenState) => {
      state.viewsToOpen = [];
    },
  },
});

export const selectViewsToOpen = (state: ViewsToOpenRootState) => state[viewsToOpenSliceName].viewsToOpen;

export const { showRegisteredViews, clearRegisteredViews } = viewsToOpenSlice.actions;
export const viewsToOpenReducer = viewsToOpenSlice.reducer;
